import type { FilterModule } from "../index";
import { PromotionDateFilter } from "./PromotionDateFilter";
import { getChips, getCount } from "./chips";
import { fromCompanyFilters, toCompanyFilters } from "./mapper";
import { defaultPromotionDateSlice, type PromotionDateSlice } from "./slice";

export type { PromotionDateSlice } from "./slice";
export { defaultPromotionDateSlice } from "./slice";

export const promotionDateModule: FilterModule<PromotionDateSlice> = {
  key: "promotionDate",
  defaultSlice: defaultPromotionDateSlice,
  Component: PromotionDateFilter,
  getChips,
  getCount,
  toCompanyFilters,
  fromCompanyFilters,
};
